import "./TfStoreConfirmStep.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {TfStoreViewStore} from "../../services/TfStoreViewStore";
import {ReplaySubject, Subject} from "rxjs";
import {StripeCardSummaryRecord} from "../../../../stripe/models/StripeBillingRecord";
import {StoreProductStates} from "../../../common/models/StoreProductState";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";
import {Pair} from "../../../../js/util/UtilFunctions";
import {ProductPrices, ProductBillingPrices} from "../../models/TfStorePrices";
import {StoreOrderItemLine} from "../../../common/components/order-items/models/StoreOrderItemLine";
import {TfProductMappings, TfStoreProduct} from "../../models/TfStoreProduct";

export const ConfirmStep = "tfStoreConfirmStep";

export function confirmStep(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/confirm/TfStoreConfirmStep.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: TfStoreConfirmStepController
    };
}

export class TfStoreConfirmStepController implements IOnInit, IOnDestroy {

    public viewStore: TfStoreViewStore;

    public orderItems: Array<StoreOrderItemLine>;
    public card: StripeCardSummaryRecord | null;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        this.viewStore
            .productStates
            .takeUntil(this.destroyed$)
            .map((states) => this.buildOrderItems(states))
            .subscribe((items) => {
                this.$scope.$applyAsync(() => this.orderItems = items);
            });
        this.viewStore
            .currentCard
            .takeUntil(this.destroyed$)
            .subscribe((card) => {
                this.$scope.$applyAsync(() => this.card = card);
            });
    }

    private buildOrderItems(states: StoreProductStates<TfStoreProduct>): Array<StoreOrderItemLine> {
        return ObjectUtil.keys(states)
                         .map((k) => Pair(k, states[k]))
                         .filter((p) => p[1].selected)
                         .filter((p) => p[1].locked === false)
                         .filter((p) => p[1].inBundle === false)
                         .map((k) => this.buildLineItem(k[0]));
    }

    private buildLineItem(product: TfStoreProduct): StoreOrderItemLine {
        const mapping = TfProductMappings[product];
        const interval = this.viewStore.billingCycle || "MONTH";
        const price = ProductBillingPrices[product][interval];
        const description = mapping.description;
        return {
            description,
            price
        };
    }

    public cardChanged(card: StripeCardSummaryRecord) {
        this.viewStore.updateCard(card);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
